import { render } from "./CarouselDangerZone.vue?vue&type=template&id=78ea789e&scoped=true"
import script from "./CarouselDangerZone.vue?vue&type=script&lang=js"
export * from "./CarouselDangerZone.vue?vue&type=script&lang=js"

import "./CarouselDangerZone.vue?vue&type=style&index=0&id=78ea789e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ea789e"]])

export default __exports__